module.exports = __webpack_public_path__ + "static/paul-background-dbe76617fe5647b704a355f926a75c0e.jpg";